import { baseState, baseMutations } from '@/store/mixins'
import home from '@/api/service-management/home'

export const state = {
  ...baseState
}

export const getters = {}

export const mutations = {
  ...baseMutations
}

export const actions = {
  getServiceRequest(context) {
    return home.getServiceRequest()
  }
}
